import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-wifi-signal-strength',
  templateUrl: './wifi-signal-strength.component.html',
  styleUrls: ['./wifi-signal-strength.component.scss']
})
export class WifiSignalStrengthComponent implements OnInit {
  @Input() signalStrength: string = '';
  @Input() showText: boolean = true;
  @Input() showFullText: boolean = false;
  
  signalBars: number[] = [];
  maxBars: number = 5;
  displayText: string = '';

  ngOnInit(): void {
    this.calculateSignalBars();
  }

  ngOnChanges(): void {
    this.calculateSignalBars();
  }

  private calculateSignalBars(): void {
    this.signalBars = [];
    
    if (!this.signalStrength) {
      return;
    }

    // Parse signal strength from formats like "4/5", "3/5", "80%", "75", etc.
    let strength: number = 0;
    
    if (this.signalStrength.includes('/')) {
      // Format: "4/5" or "4/5 (RSSI: -33 dBm)"
      // Extract only the rating part (before any space or parenthesis)
      const ratingMatch = this.signalStrength.match(/^(\d+\/\d+)/);
      this.displayText = ratingMatch ? ratingMatch[1] : this.signalStrength;
      const parts = this.displayText.split('/');
      strength = parseInt(parts[0]) || 0;
      this.maxBars = parseInt(parts[1]) || 5;
    } else if (this.signalStrength.includes('%')) {
      // Format: "80%"
      strength = parseInt(this.signalStrength.replace('%', '')) || 0;
      this.maxBars = 5;
      strength = Math.round((strength / 100) * this.maxBars);
      this.displayText = `${strength}/${this.maxBars}`;
    } else {
      // Format: "75" (assume out of 100)
      strength = parseInt(this.signalStrength) || 0;
      this.maxBars = 5;
      strength = Math.round((strength / 100) * this.maxBars);
      this.displayText = `${strength}/${this.maxBars}`;
    }

    // Create array of bars
    for (let i = 1; i <= this.maxBars; i++) {
      this.signalBars.push(i <= strength ? 1 : 0);
    }
  }

  getBarClass(index: number): string {
    const isActive = this.signalBars[index] === 1;
    const barNumber = index + 1;
    
    if (!isActive) {
      return 'signal-bar inactive';
    }
    
    // Different colors based on signal strength
    if (barNumber <= 2) {
      return 'signal-bar weak';
    } else if (barNumber <= 3) {
      return 'signal-bar fair';
    } else if (barNumber <= 4) {
      return 'signal-bar good';
    } else {
      return 'signal-bar excellent';
    }
  }
} 
